export enum CargoCompanyListRequestOrder {
  COMPANY_NAME_ASC = "COMPANY_NAME_ASC",
  COMPANY_NAME_DESC = "COMPANY_NAME_DESC",
  DISPLAY_NAME_ASC = "DISPLAY_NAME_ASC",
  DISPLAY_NAME_DESC = "DISPLAY_NAME_DESC",
}

export type CargoCompanyListRequestQueryParams = {
  taxId?: string;
  regon?: string;
  krsNo?: string;
  companyName?: string;
  companyNameCaseSensitive?: boolean;
  displayName?: string;
  displayNameCaseSensitive?: boolean;
  headquartersAddressString?: string;
  headquartersAddressStringCaseSensitive?: boolean;
  contractMaintenancePolicy?: string;
  notes?: string;
  notesCaseSensitive?: string;
  order?: CargoCompanyListRequestOrder;
  creationStart?: Date;
  creationEnd?: Date;
};

type CargoCompanyListRequest = {
  taxId?: string;
  regon?: string;
  krsNo?: string;
  companyName?: string;
  companyNameCaseSensitive?: boolean;
  displayName?: string;
  displayNameCaseSensitive?: boolean;
  headquartersAddressString?: string;
  headquartersAddressStringCaseSensitive?: boolean;
  contractMaintenancePolicy?: string;
  notes?: string;
  notesCaseSensitive?: string;
  order?: CargoCompanyListRequestOrder;
  creationStart?: Date;
  creationEnd?: Date;
};

export default CargoCompanyListRequest;
